import {AdresseDeLivraison, LivraisonTolede} from 'api-types/ffconnect';

/**
 * Adresse de la livraison sélectionnée : celle de son panier, sinon la première adresse du client.
 * `undefined` tant que les adresses ne sont pas chargées, ou si le client n'en a aucune.
 */
export const adresseDeLaLivraisonSelectionnee = <
  A extends {
    tolede: Pick<AdresseDeLivraison['tolede'], 'code_adresse_de_livraison'>;
  },
>({
  adresses,
  panier,
  date_de_livraison,
}: {
  adresses: A[] | undefined;
  panier:
    | {
        livraison_tolede: Pick<
          LivraisonTolede,
          'code_adresse_de_livraison' | 'date_de_livraison'
        >;
      }
    | undefined;
  date_de_livraison: string;
}) => {
  // Quand le client choisit une autre date de livraison, `date_de_livraison` change aussitôt,
  // mais useHalState renvoie encore l'ancien panier jusqu'à l'arrivée du nouveau. Sans ce test,
  // on renverrait un moment l'adresse de l'ancien panier. Tant que le bon panier n'est pas là,
  // ou s'il n'y en a pas, on retombe sur la première adresse du client.
  const codeAdressePanier =
    panier?.livraison_tolede.date_de_livraison === date_de_livraison
      ? panier.livraison_tolede.code_adresse_de_livraison
      : undefined;

  return (
    adresses?.find(
      (adresse) =>
        adresse.tolede.code_adresse_de_livraison === codeAdressePanier,
    ) ?? adresses?.[0]
  );
};
